import axios, { AxiosRequestConfig } from 'axios'
import getConfig from 'next/config'
import { showToast } from './toast'

export function AxiosDefault() {
  return axios.create({
    baseURL: getConfig().publicRuntimeConfig.apiBasePath,
    timeout: 30000,
    withCredentials: true
  })
}

export function Axios(config: AxiosRequestConfig) {
  const instance = axios.create(config)
  // Add a request interceptor
  instance.interceptors.request.use(
    (config) => {
      // Do something before request is sent
      return config
    },
    (error) => {
      // Do something with request error
      showToast({
        severity: 'error',
        summary: `Request error: ${error?.response?.data?.title || ''} ${error?.response?.status || ''}`,
        detail: `${error.message}`
      })
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  instance.interceptors.response.use(
    (response) => {
      // Do something with response data
      return response
    },
    (error) => {
      const data = error?.response?.data

      const code = data?.error?.error_details?.error_code || error?.response?.status || ''
      console.log('Error code', code)

      const title = getMsg(data?.title)

      const message =
        getMsg(data?.error?.error_details?.message) ||
        getMsg(data?.detail) ||
        getMsg(data) ||
        getMsg(error.message) ||
        title ||
        ''

      showToast({
        severity: 'error',
        summary: `Error: ${title}`,
        detail: `${message}`
      })
      return Promise.reject(error)
    }
  )

  return instance
}

const getMsg = (message: any) => (typeof message == 'string' ? message : '')
